import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import List from '@material-ui/core/List';
import { Document, Page, pdfjs } from 'react-pdf';
import { withRouter } from 'react-router-dom';
import withSizes from 'react-sizes';
import CircularProgress from '@material-ui/core/CircularProgress';
import AdminAcceptRejectBox from '../NavTabs/AdminAcceptRejectBox'
import Iframe from 'react-iframe'
import PDF from '../Onboarding/PDF'
import leftIcon from '../../images/left.png'
import Button from "@material-ui/core/Button";
import UploadDocsSingleFile from '../../containers/Onboarding/UploadDocsSingleFile'
import PropTypes from "prop-types";
import { getCaseIdFromUrl } from '../../utils/caseIdFromUrl';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const styles = theme => ({
    textColor: {
        color: '#a52423'
    },
    divStyle: {
        paddingLeft: '5%',
        // paddingTop: '30px',
        // paddingRight: '340px',
        // paddingBottom: '70px',
        // // border: 'none'
        // align:'center',
        // textAlign: 'center'

    },
    padding: {
        padding: '30px'
    },
    subText: {
        color: '#a52423',
    },
    container:{
        align:'center',
        textAlign: 'center'
    },
    paper:{
        align:'center',
        textAlign: 'center'
    }
});

class ArbitratorNotice extends Component {

    state = {
        numPages: null,
        pageNumber: 1,
        typeOfAccount:localStorage.getItem('typeOfAccount'),
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    componentWillUpdate() {

    }

    checkLanguage = function() {
        try{
        //   if (this.props.isLoading){
        //     setTimeout(()=>{this.checkLanguage()},100)
        //   }
        //   else{
            console.log('this caseData: '+JSON.stringify(this.props.caseData))
            var lang = localStorage.getItem('language');
            if (this.props !== undefined){
              if (this.props.caseData !== undefined){
                if (this.props.caseData.language !== undefined){
                  if (this.props.caseData.language == 'Chi'){
                    if (lang == 'en' || lang == undefined){
                      localStorage.setItem('language', 'cn');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                  else if (this.props.caseData.language == 'Eng'){
                    if (lang == 'cn' || lang == undefined){
                      localStorage.setItem('language', 'en');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                }
              }
            }
        //   }
        }catch(err){
          setTimeout(()=>{this.checkLanguage()},100)
        }
      }

    componentDidMount() {
        // this.props.getCaseInfo(this.props.match.params.id);
        this.props.getCaseInfo(
                        getCaseIdFromUrl(),
            localStorage.getItem("token")
          );
        this.checkLanguage();
    }

    render() {

        const { classes, file } = this.props;
        let { numPages, pageNumber } = this.state;
        console.log('**this.props.caseData.conversationId: '+this.props.caseData.conversationId)
        let fileURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.caseData.conversationId}`;
        let fileURLNoName = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.caseData.conversationId}`;
        let fileDocURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getDoc/?id=${this.props.conversationId}_arbitrationNotice`;

        if(this.props.loadingCaseInfo){
            console.log('AN loadingCaseInfo')
            return(
                <CircularProgress size={50} thickness={3} className={classes.progress}/>
            );
        }
        else{
            console.log('!AN loadingCaseInfo')
            if (this.props.caseData.agreement_type == 'other_dispute'){
                return (
                    <div style={{ marginBottom:'40%' }}>
                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                        {(this.state.typeOfAccount == 'admin') && (this.props.caseData.isAccepted == false) && <AdminAcceptRejectBox/>}
                        
                        <PDF file={fileURL} fileURLNoName={fileURLNoName} isDesktop={this.props.isMobile} wordFile={fileDocURL} ></PDF>
                    </div>
                );
            }
            else{
                return (
                    <div style={{ marginBottom:'40%' }}>
                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                        
                        <PDF file={fileURL} fileURLNoName={fileURLNoName} isDesktop={this.props.isMobile} wordFile={fileDocURL}></PDF>
                    </div>
                );
            }
        }

       
        
    }

}

const mapStateToProps = (state) => {
    // console.log('mapStateToProps: state: ' + JSON.stringify(state));
    return {
        error: state.caseInfo.error,
        conversationId: state.caseInfo.conversationId,
        caseId: state.caseInfo.caseId,
        caseData: state.caseInfo.caseData,
        loadingCaseInfo: state.caseInfo.loading,
    }
}

const mapSizesToProps = sizes => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet : withSizes.isTablet(sizes),
    isDesktop : withSizes.isDesktop(sizes),
    isGtMobile : withSizes.isGtMobile(sizes),
    isGtTablet : withSizes.isGtTablet(sizes),
    isStTablet : withSizes.isStTablet(sizes),
    isStDesktop : withSizes.isStDesktop(sizes),
    isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes)
})

ArbitratorNotice.contextTypes = {
    t: PropTypes.func,
  };

const mapDispatchToProps = (dispatch) => {
    return {
        getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
    }
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps) (withRouter(ArbitratorNotice))) );